import { addDays } from './add-days';
import { addYearsToString } from './add-years-to-string';

/**
 * Calculates and returns a birthdate string by subtracting a given number of years from a given date.
 *
 * @param years - The number of years to subtract from the given date.
 * @param date - The reference date to subtract years from (default is the current date).
 * @param dayBefore - If `true`, returns the birthdate one day before the calculated date (default is `false`).
 * @returns A string representing the calculated birthdate.
 */
export function birthDateByAge(
  years: number,
  date: Date,
  dayBefore = false,
): string {
  const today = new Date();
  const checkedDate = years === 0 ? today : date;

  return addYearsToString(
    -years,
    dayBefore ? addDays(checkedDate, 1) : checkedDate,
  );
}
